function accordion() {
  const servicesSection = document.querySelector('.accordion-column');
  if (!servicesSection) return;

  const servicesTitles = servicesSection.querySelectorAll('.heading');

  servicesTitles.forEach(title => {
    title.addEventListener('click', function() {
      const servicesItem = this.closest('.item');
      const servicesBody = servicesItem.querySelector('.body');

      if (servicesItem.classList.contains('active')) {
        servicesItem.classList.remove('active');
        servicesBody.style.height = '0';
      } else {
        servicesSection.querySelectorAll('.item').forEach(item => {
          const body = item.querySelector('.body');
          item.classList.remove('active');
          body.style.height = '0';
        });

        servicesItem.classList.add('active');
        servicesBody.style.height = `${servicesBody.scrollHeight}px`;
      }
    });
  });
}


export default accordion;
